import { routerSlice } from '@wellesley/router'
import { useEffect, MutableRefObject } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useCurrentFullPath } from './useCurrentFullPath'
import { requestChangePath } from '../../api/actions'

type UseHostSyncPathProps = {
  lastLocationPathRef: MutableRefObject<string>
}
export const useHostSyncPath = ({
  lastLocationPathRef,
}: UseHostSyncPathProps) => {
  const dispatch = useDispatch()
  const currentFullPath = useCurrentFullPath()

  const path = useSelector(routerSlice.selectors.selectPath)
  const transitionPath = useSelector(routerSlice.selectors.selectTransitionPath)

  useEffect(() => {
    if (currentFullPath !== lastLocationPathRef.current) {
      lastLocationPathRef.current = currentFullPath

      if (currentFullPath !== path && currentFullPath !== transitionPath) {
        dispatch(requestChangePath(currentFullPath))
      }
    }
  }, [path, transitionPath, currentFullPath])
}
